import { useMemo } from 'react'

import type { WidgetState } from '@liveHelper/models/fsm/machine'
import { parseUIContext } from '@liveHelper/models/fsm/machine'

import { useLocalStorage } from '@core/hooks/useLocalStorage'

/**
 * Returns the widget state from the UI context.
 */
export const useTopLevelUIState = (): WidgetState => {
  const [liveHelperUiContext] = useLocalStorage('liveHelperUiContext')

  const persistedUIContextCache = useMemo(
    () => parseUIContext(liveHelperUiContext),
    [liveHelperUiContext],
  )

  return persistedUIContextCache.widgetState
}
